import fetcher from '../lib/fetcher'
import {
  TDictionary,
  TDictionariesPaginated,
  TUpdateDictionary,
} from '../types/dictionary.types'

const getDictionariesByClient = async (
  clientId: string,
  page?: number,
  perPage?: number,
  search?: string,
) => {
  if (page && perPage) {
    const qs = new URLSearchParams({
      page: String(page),
      perPage: String(perPage),
      ...(search ? {search} : {}),
    }).toString()
    const response = await fetcher.get<TDictionariesPaginated>(
      `/api/dictionary/${clientId}/paginated?${qs}`,
    )
    return response.data
  }
  const response = await fetcher.get<TDictionary[]>(
    `/api/dictionary/${clientId}`,
  )
  return response.data
}

const updateDictionary = async (dictionaryData: TUpdateDictionary) => {
  return fetcher.patch(`/api/dictionary/${dictionaryData.id}`, dictionaryData)
}

export const DictionaryService = {
  getDictionariesByClient,
  updateDictionary,
}
